export default __webpack_public_path__ + "static/media/yellowCubeSide.cbcef307.svg";